import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../Footer";
import PaymentForm from "../components/PaymentForm";
import TestView from "../components/TestView";
import StepProgress from "../components/StepProgress";
import ExpertValidation from "../components/ExpertValidation";

export default function TestPrescription() {
	const { t, i18n } = useTranslation();
	const { id } = useParams();
	const [status, setStatus] = useState("loading");
	const [state, setState] = useState(null);
	const [currentStep, setCurrentStep] = useState(3);
	const [amount, setAmount] = useState({});
	const [user, setUser] = useState({});
	const [prescription, setPrescription] = useState({});
  const initialSteps = [
    { id: 1, label: t("Prescription Uploaded"), completed: true },
    { id: 2, label: t("Exam Completed"), completed: true },
    { id: 3, label: t("Payment"), completed: false },
    { id: 4, label: t("Expert Validation"), completed: false },
    { id: 5, label: t("Results"), completed: false },
  ];
  const [steps, setSteps] = useState(initialSteps);
	
	useEffect(() => {
		axios
			.get(`${process.env.REACT_APP_API}/user/test/${id}?lng=${i18n.language}`, {
				withCredentials: true,
			})
			.then(function (res) {
				if (res.data.result) {
					const step = res.data.step;
					setState(res.data);
					setAmount({ amount: res.data.amount, amountDiscounted: null, amountTotal: res.data.amount, currency: res.data.currency });
					setUser({ name: res.data.user.name, email: res.data.user.email, mobileNumber: res.data.user.mobileNumber, lastName: res.data.user.lastName });
					setPrescription(res.data.prescription);
					setCurrentStep(step);
					const updatedSteps = [...steps];

					updatedSteps.forEach((oldStep, index) => {
						if (oldStep.id < step) {
							updatedSteps[index].completed = true;
						}
						if (step === 5) updatedSteps[updatedSteps.length - 1].completed = true;
					});
					
					(step === 5) ? setCurrentStep(6) : setCurrentStep(step);
					setSteps(updatedSteps);

					if (step === 4) {
						setStatus("expert-validation");
					} else if (step === 5) {
							setStatus("prescription");
					} else {
						setStatus("payment");
					}
				} else {
					setStatus("error");
				}
			})
			.catch((e) => {
				setStatus("error");
			});
	}, []);

	return state && (
		<>
      <Header />
      <div className="thank-you-page">
        <div className="thank-you-container">
          <StepProgress steps={steps} currentStep={currentStep} />
          {status === "payment" && <PaymentForm
						setAmount={setAmount}
						prescription={prescription}
            amount={amount}
            user={user}
            setCurrentStep={setCurrentStep}
            setStatus={setStatus}
            steps={steps}
            setSteps={setSteps}
          />}
          {status === "expert-validation" && <ExpertValidation />}
          {status === "prescription" && <TestView data={prescription} />}
        </div>
      </div>
      <Footer />
    </>
	);
}
